import React, { useEffect, useState, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Dropdown } from "antd"
import { DownOutlined } from "@ant-design/icons"
import AntdTable from "src/components/AntdTable/Table"
import AntdMobileTable from "src/components/AntdMobileTable/AntdMobileTable"
import {
  getPointsRulesActions,
  addPointsRulesActions,
  editPointsRulesActions,
  deletePointsRulesActions,
} from "src/store/Slices/UsersRatingSlice"
import TableTitle from "src/pages/Administrator/Helpers/TableTitle"
import AddEditModal from "./Modals/AddEditModal"
import DeleteRulesModal from "./Modals/DeleteModal"

const AccuralPointsRules = ({ mnemo }) => {
  const dispatch = useDispatch()
  const searchInput = useRef(null)

  const [isAddEditModalOpen, setIsAddEditModalOpen] = useState({
    open: false,
    flag: "",
    ruleData: null,
  })

  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(20)

  const pointsRulesData = useSelector(
    (state) => state.UsersRatingSlice?.accuralPointsRules,
  )

  const loading = useSelector((state) => state.UsersRatingSlice?.isLoading)

  const rows =
    pointsRulesData?.data?.value?.rows?.map((element) => {
      return {
        key: element?.key,
        id: element?.id,
        actionTypeId: element?.actionTypeId,
        actionTypeName: element?.actionTypeName,
        points: element?.points,
        isActive: element?.isActive,
        minutesFromLastAction: element?.minutesFromLastAction,
      }
    }) || []

  useEffect(() => {
    dispatch(getPointsRulesActions())
  }, [dispatch])

  const handleAddRule = () => {
    setSelectedRecord(null)
    setIsAddEditModalOpen({
      open: true,
      flag: "add",
      ruleData: null,
    })
  }

  const getDropdownItems = (record) => {
    const items = []

    items.push({
      key: "edit",
      label: "Редактировать",
      onClick: () => {
        setIsAddEditModalOpen({
          open: true,
          flag: "edit",
          ruleData: record,
        })
      },
    })

    items.push({
      key: "delete",
      label: "Удалить",
      onClick: () => {
        setSelectedRecord(record)
        setIsOpenDeleteModal(true)
      },
    })

    return items
  }

  const filterOptionsArr = [
    { label: "Фильтрация", value: 0, index: undefined },
    { label: "По ID", value: 1, index: "id", title: "ID" },
    {
      label: "По типу действия",
      value: 2,
      index: "actionTypeName",
      title: "Тип действия",
    },
    { label: "По баллам", value: 3, index: "points", title: "Баллы" },
    { label: "По статусу", value: 4, index: "isActive", title: "Статус" },
  ]

  const searchItemsMap = (keys, values) => {
    const formattedItems = {}
    if (keys && values) {
      keys.forEach((key, index) => {
        if (values[index] && values[index][0]) {
          if (key === "id") {
            formattedItems["idFrom"] = values[index][0]
            formattedItems["idTo"] = values[index][1]
          } else if (key === "points") {
            formattedItems["pointsFrom"] = values[index][0]
            formattedItems["pointsTo"] = values[index][1]
          } else if (key === "actionTypeName") {
            formattedItems["actionTypeName"] = values[index][0]
          } else if (key === "isActive") {
            formattedItems["isActive"] = values[index][0]
          } else {
            formattedItems[key] = values[index][0]
          }
        }
      })
      return formattedItems
    }
    return {}
  }

  const handleTableChange = (pagination, filters, sorter) => {
    const payload = searchItemsMap(Object.keys(filters), Object.values(filters))
    dispatch(
      getPointsRulesActions({
        count: pagination.pageSize,
        offset: pagination.pageSize * (pagination.current - 1),
        orderBy: sorter?.column?.dataIndex,
        isDesc: sorter.order
          ? sorter.order === "ascend"
            ? false
            : true
          : undefined,
        ...payload,
      }),
    )
    setPage(pagination.current)
    setPageSize(pagination.pageSize)
  }

  const clickOnAction = (element) => {
    setSelectedRecord(element)
  }

  const handlePaginationChange = (page, pageSize) => {
    dispatch(
      getPointsRulesActions({
        count: pageSize,
        offset: pageSize * (page - 1),
      }),
    )
    setPage(page)
    setPageSize(pageSize)
  }

  const onClickSearchItem = (selectedKeys, dataIndex) => {
    setPage(1)
    setPageSize(20)
    dispatch(
      getPointsRulesActions({
        [`${dataIndex}`]: selectedKeys[0],
      }),
    )
  }

  const baseColumns = pointsRulesData?.data?.value?.columns || []

  const columns = [
    ...baseColumns.map((element) => {
      if (element.dataIndex === "isActive") {
        return {
          ...element,
          render: (value) => (value ? "Да" : "Нет"),
        }
      }
      return {
        ...element,
      }
    }),
    {
      title: "Действия",
      key: "actions",
      width: 100,
      align: "center",
      render: (_, record) => {
        const items = getDropdownItems(record)

        return (
          <Dropdown
            menu={{
              items: items,
            }}
            trigger={["click"]}
            placement='bottomRight'
          >
            <a
              className='text-primary text-decoration-none'
              onClick={(e) => e.stopPropagation()}
              style={{ cursor: "pointer" }}
            >
              Действия <DownOutlined />
            </a>
          </Dropdown>
        )
      },
    },
  ]

  useEffect(() => {
    console.log("pointsRulesData", pointsRulesData)
    console.log("columns", columns)
    console.log("rows", rows)
    console.log("totalCount", pointsRulesData?.data?.value?.totalCount)
  }, [columns, rows])

  const onClickDelete = () => {
    if (selectedRecord?.id) {
      dispatch(deletePointsRulesActions(selectedRecord.id)).then(() => {
        setIsOpenDeleteModal(false)
        dispatch(getPointsRulesActions())
      })
    }
  }

  return (
    <>
      <AddEditModal
        visible={isAddEditModalOpen}
        setVisible={setIsAddEditModalOpen}
        setPage={setPage}
        setPageSize={setPageSize}
      />

      <DeleteRulesModal
        visible={isOpenDeleteModal}
        setVisible={setIsOpenDeleteModal}
        onClickYes={onClickDelete}
      />

      {window.innerWidth >= 768 ? (
        <AntdTable
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          onChange={handleTableChange}
          loading={loading}
          onClickRowOne={clickOnAction}
          columns={columns}
          rows={rows}
          total={pointsRulesData?.data?.value?.totalCount || 0}
          title={() => (
            <TableTitle onClickOpenModal={handleAddRule} mnemoButton={false} />
          )}
        />
      ) : (
        <AntdMobileTable
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          elementsList={columns}
          elementsListLoading={loading}
          setIsOpenAddEditModal={false}
          setIsOpenDeleteModal={false}
          handlePaginationChange={handlePaginationChange}
          onChange={handleTableChange}
          clickOnAction={clickOnAction}
          filterOptionsArr={filterOptionsArr}
          searchInput={searchInput}
          onClickSearchItem={onClickSearchItem}
        />
      )}
    </>
  )
}

export default AccuralPointsRules
